import type { ContentEntry } from "@/types/content";

export const REVIEW_STATUS_LABEL: Record<string, string> = {
  DRAFT: "مسودة",
  SUBMITTED: "قيد المراجعة",
  APPROVED: "موافَق عليه",
  REJECTED: "مرفوض",
};

type ReviewStatus = keyof typeof REVIEW_STATUS_LABEL;

function normalizeReviewStatus(entry: ContentEntry): ReviewStatus {
  const raw = typeof entry.reviewStatus === "string" ? entry.reviewStatus : "DRAFT";
  return raw in REVIEW_STATUS_LABEL ? (raw as ReviewStatus) : "DRAFT";
}

/** Published live version exists but the working draft has newer unpublished edits. */
export function hasPendingEdits(entry: ContentEntry): boolean {
  return Boolean(entry.published) && normalizeReviewStatus(entry) === "DRAFT";
}

export function getReviewStatus(entry: ContentEntry): ReviewStatus {
  return normalizeReviewStatus(entry);
}
